import React from "react";
import { IoMdCloseCircle } from "react-icons/io";
const ImageComponent = ({ src, alt, onDelete }) => {
  const containerStyle = {
    margin: "5px",
    width: "50px",
    height: "50px",
    overflow: "hidden",
    position: "relative",
    border: " 1px solid #dbd8d8",
    borderRadius: " 10px 10px 10px 10px",
    backgroundColor: "#dbd8d8",
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
  };

  return (
    <div style={{ position: "relative" }}>
      <IoMdCloseCircle
        onClick={onDelete}
        style={{
          position: "absolute",
          color: "#696969",
          right: 0,
          cursor: "pointer",
          //   transform: "translateY(-4px)",
          zIndex: 10,
        }}
      />
      <div style={containerStyle}>
        <img style={imageStyle} src={src} alt={alt} />
      </div>
    </div>
  );
};

export default ImageComponent;
